var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5858 1.58579C12.3668.804738 13.6332.804738 14.4142 1.58579 15.1953 2.36683 15.1953 3.63316 14.4142 4.41421L13.6213 5.20711 10.7929 2.37868 11.5858 1.58579zM9.37868 3.79289L1 12.1716V15H3.82842L12.2071 6.62132 9.37868 3.79289z",
    fill: "currentColor"
  })));
}

export default SvgWrite;